import config from '../config';

const URLs = {
  assetsBaseUrl: process.env.REACT_APP_ASSET_URL,
  apisV1: '/v1',
  apisV2: '/v2',
  CREATE_PRODUCT: '/custom-builder/product',
  CUSTOM_PDP: '/on/demandware.store/Sites-Helzberg-Site/en_US/Product-Show',
  favorite: '/v1/favorites',
  syncFavorites: '/v1/favorites/sync',
  BASE_PRODUCT_URL:
    '/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE',
  ...config
};
export default URLs;
